// Подробная диагностика расчёта (наборы номенклатуры, нормы поддонов) печаталась
// всегда. Логи полезные, но собираются они на каждый рендер и проходят по словарю
// на тысячи позиций — в Битриксе, где калькулятор живёт в iframe, это заметная
// работа впустую.
//
// Поэтому подробный режим включается вручную и держится в localStorage:
//
//   localStorage.setItem('calcDebug', '1'); // включить, затем перезагрузить вкладку
//   localStorage.removeItem('calcDebug');   // выключить
//
// Короткие опорные логи (запрос сравнения, смена набора номенклатуры) остаются
// на месте и печатаются всегда — по ним видно, что вообще происходит на экране.
let cachedFlag = null;

export const isCalcDebugEnabled = () => {
  if (cachedFlag !== null) {
    return cachedFlag;
  }

  try {
    cachedFlag = typeof window !== "undefined" && window.localStorage?.getItem("calcDebug") === "1";
  } catch {
    // Приватный режим и заблокированные куки: диагностика не настолько важна,
    // чтобы из-за неё падал расчёт.
    cachedFlag = false;
  }

  return cachedFlag;
};

export default isCalcDebugEnabled;
